import RoleSelectDialog from './RoleSelectDialog';

export default RoleSelectDialog;
